import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {DataTableDirectives} from "angular2-datatable/datatable";
import {FORM_DIRECTIVES, FORM_PROVIDERS, REACTIVE_FORM_DIRECTIVES, FormControl, FormGroup} from "@angular/forms";
import {AlertComponent, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from "ng2-bootstrap/ng2-bootstrap";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {OperatorsService} from "../../service/operators.service";
import {User} from "../../domain/user";
import {Page} from "../../domain/page";
import {LoginService} from "../../service/login.service";

@Component({
    selector: 'config-operators',
    template: require('./config.operators.component.html'),
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe],
})
export class ConfigOperatorsComponent {

    public data:User[];
    public userLogged:User;

    private filter:string;

    public error:any;

    private currentPage:Page;

    public form:FormGroup;

    public itemsPerPage:number;
    public loading:boolean;
    public page:number;
    public total:number;

    public userSelected:User;

    constructor(private router:Router,
                private operatorsService:OperatorsService,
                private loginService:LoginService) {
        this.init();

        this.form.valueChanges
            .debounceTime(400)
            .subscribe(this.find.bind(this));

        this.find();
    }

    private init():void {
        this.data = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.filter = "";
        this.form = new FormGroup({
            search: new FormControl(),
            itemsPerPage: new FormControl()
        });
    }

    public find():void {
        this.getData(1);
    }

    private getData(page:number):void {
        this.error = null;
        this.loading = true;

        this.operatorsService.findUsers(this.filter, page, this.itemsPerPage).subscribe(
            (data) => {
                this.refreshData(data);
                this.page = page;
            },
            () => {
                this.bindError('Ocurrió un error al buscar los operadores.');
            });

        this.userLogged = this.loginService.getUserLogged();
    }

    private refreshData(page:Page):void {
        this.data = page.content.map(user => new User(user));
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public remove(deleteModal:any):void {
        this.error = null;
        this.operatorsService.delete(this.userSelected.id)
            .subscribe(
                () => {
                    deleteModal.hide();
                    this.removeFromView(this.userSelected);
                },
                () => {
                    this.bindError('Ocurrió un error al eliminar el operador.');
                });
    }

    private removeFromView(user:User):void {
        let index = this.data.indexOf(user);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.userSelected = null;
    }

    public edit(user:User):void {
        this.router.navigate(['app/home/config/editOperator', user.id]);
    }

    public create():void {
        this.router.navigate(['app/home/config/createOperator']);
    }

    public getPage(page:number):void {
        this.getData(page);
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/operators/config.operators.component.ts
 **/